import { Checkbox } from 'antd';
import cn from 'classnames';
import React from 'react';

import { ReactComponent as ArrowDown } from '@/app/_icons/arrow-down.svg';
import { ChildFilter, ParentFilter } from '@/types/filters/filters.types';

import { Option } from '../option/option';

import styles from './group-heading.module.scss';

export const GroupHeading: React.FC<{
  selectOption: (optionToUpdate: ParentFilter | ChildFilter) => void;
  option: ParentFilter;
  hideText: string;
  openText?: string;
  setOptionsState: (
    updateFn: (prevState: ParentFilter[]) => ParentFilter[],
  ) => void;
}> = ({ option, selectOption, hideText, openText }) => {
  const [open, setOpen] = React.useState(false);
  const openCloseLabel = open ? hideText : openText;
  const hasChildren = (option.children?.length as number) > 0;
  const isNotAllSubOptionsChecked = option?.children?.some(
    (option) => option.isChecked === false,
  );
  const isAllSubOptionsUnchecked = option?.children?.every(
    (option) => option.isChecked === false,
  );
  const isAnySubOptionsChecked = option?.children?.some(
    (option) => option.isChecked === true,
  );

  function toggleOpen() {
    setOpen((open) => !open);
  }

  return typeof option.vehicleCount !== 'number' || option.vehicleCount ? (
    <>
      <div
        className={cn(styles.groupHeading, {
          [styles.groupHeadingSelected as string]: open,
          [styles.groupHeadingOptionChecked as string]: isAnySubOptionsChecked,
        })}
      >
        <Checkbox
          className={styles.groupHeadingInput}
          checked={option.isChecked || !isAllSubOptionsUnchecked}
          indeterminate={!isAllSubOptionsUnchecked && isNotAllSubOptionsChecked}
          onChange={() => {
            selectOption(option);
          }}
        />
        <div
          className={styles.groupHeadingContent}
          onClick={() => {
            hasChildren && toggleOpen();
          }}
        >
          <span>{option.name}</span>
          {option.vehicleCount && (
            <span className={styles.groupHeadingAmount}>
              ({option.vehicleCount})
            </span>
          )}
          {hasChildren && (
            <>
              <span className={styles.groupHeadingCloseLabel}>
                {openCloseLabel}
              </span>
              <ArrowDown
                className={cn(styles.groupHeadingArrow, {
                  [styles.groupHeadingArrowOpened as string]: open,
                })}
              />
            </>
          )}
        </div>
      </div>
      {open &&
        option.children?.map((option) => (
          <Option
            key={option.id}
            option={option}
            selectOption={() => selectOption(option)}
          />
        ))}
    </>
  ) : null;
};
